import adminMiddleware from "@/components/email/admin/ducks/middleware"
import userMiddleware from "@/components/email/ducks/middleware"
import internalMiddleware from "@/components/email/internal/ducks/middleware"

export default [adminMiddleware, userMiddleware, internalMiddleware]
